module.exports = __webpack_public_path__ + "static/media/04.7aa545f1.jpg";